export const portfolioCarusel = () => {
    const carusel = {
        el: document.querySelector('.portfolio__carusel-container'),
        slides: [],
        setActiveIndex(newActiveIndex) {
            this.slides.forEach((slide, i) => {
                if (i == newActiveIndex) slide.state = 'active';
                if (i == newActiveIndex + 1) {
                    slide.state = 'next';
                } else if (i > newActiveIndex) {
                    slide.state = 'upcome';
                }
                if (i == newActiveIndex - 1) {
                    slide.state = 'prev';
                } else if (i < newActiveIndex) {
                    slide.state = 'passed';
                }

                if (newActiveIndex == this.slides.length - 1 && i == 0) slide.state = 'next';
                if (newActiveIndex == 0 && i == this.slides.length - 1) slide.state = 'prev';
            });
            this.update();
        },
        switchToNext() {
            let newActiveIndex = this.slides.find((s) => s.state == 'active').index + 1;
            if (newActiveIndex == this.slides.length) newActiveIndex = 0;
            this.setActiveIndex(newActiveIndex);
        },
        update() {
            this.slides.forEach((slide) => {
                slide.el.dataset.slideState = slide.state;
            });
        },
        init() {
            if (!this.el) return;
            this.slides = Array.from(this.el.children).map((el, i) => {
                let state = 'upcome';
                if (i == 0) state = 'prev';
                if (i == 1) state = 'active';
                if (i == 2) state = 'next';
                return {
                    index: i,
                    state,
                    el,
                };
            });
            this.update();

            this.interval = setInterval(this.switchToNext.bind(this), 3000);

            this.slides.forEach((slide, i) => {
                slide.el.addEventListener('click', () => {
                    this.setActiveIndex(i);
                    clearInterval(this.interval);
                    this.interval = null;
                    setTimeout(() => {
                        if (this.interval) return;
                        this.interval = setInterval(this.switchToNext.bind(this), 3000);
                    }, 5000);
                });
            });
        },
    };

    carusel.init();
};
